import { IconPropsType } from 'designSystem/types/icons';

interface IOutwardArrowIconProps extends IconPropsType {}

const OutwardArrowIcon = ({
  size = 20,
  color = '#000000',
  ...props
}: IOutwardArrowIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_478_388)">
      <circle
        cx={10}
        cy={10}
        r={10}
        transform="matrix(1 0 0 -1 0.5 20)"
        fill="#54B585"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5077 13.6047C13.1882 13.5932 12.9381 13.3146 12.9491 12.9823L13.1032 8.33654L7.59289 14.0672C7.36685 14.3023 7.00036 14.3023 6.77431 14.0672C6.54826 13.8322 6.54826 13.451 6.77431 13.2159L12.2846 7.48522L7.81749 7.64542C7.498 7.65687 7.23007 7.39681 7.21906 7.06454C7.20804 6.73227 7.4581 6.45363 7.77759 6.44217L13.7123 6.22934C13.8727 6.22359 14.0281 6.28731 14.1416 6.4053C14.255 6.52329 14.3163 6.68495 14.3107 6.85171L14.1061 13.0238C14.0951 13.3561 13.8272 13.6162 13.5077 13.6047Z"
        fill="#FDFDFD"
      />
    </g>
    <defs>
      <clipPath id="clip0_478_388">
        <rect
          width={size}
          height={size}
          fill="white"
          transform="matrix(1 0 0 -1 0.5 20)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default OutwardArrowIcon;
